import { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { mtgAPI } from '../apis/mtgAPI';

export const SetContext = createContext(null);

export const SetProvider = ({ children }) => {
	const params = useParams();
	const [sets, setSets] = useState({});
	const [loadingSets, setLoadingSets] = useState(true);
	const [activeSet, setActiveSet] = useState(null);

	useEffect(() => {
		console.log('Initialization: SetProvider');
		mtgAPI.getSets().then((respSets) => {
			let setsUpd = {};
			for (let i = 0; i < respSets.length; i++) {
				if (respSets[i].digital) continue; // Skip digital only sets
				setsUpd[respSets[i].id] = respSets[i];
			}
			// console.log(setsUpd);
			setSets(setsUpd);
			setLoadingSets(false);
		});
	}, []);

	useEffect(() => {
		if (params.set_id && params.set_id in sets) {
			// console.log('Setting active set to ', sets[params.set_id]);
			setActiveSet(sets[params.set_id]);
		} else {
			setActiveSet(null);
			// TODO: 404 not found
		}
	}, [sets, params.set_id]);

	const value = {
		sets,
		activeSet,
		loadingSets,
	};
	return <SetContext.Provider value={value}>{children}</SetContext.Provider>;
};

SetProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
